import React from 'react'
import AppBar from '../components/AppBar'
import { Box } from '@mui/material'

export interface LayoutProps{
    children:React.ReactNode
}

const Layout:React.FC<LayoutProps>=({children})=>{
    return <>
    <AppBar/>
    <Box p={2}>
        {children}
    </Box>
    
    </>
}

export default Layout